import styled from 'styled-components';

export const TotalCount = styled.div`
  margin-left: 5px;
`;
